if(!customElements.get('mega-menu-link')) {
    class MegaMenuLink extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.megaScroller = document.querySelectorAll('.t4s-type__mega.menu-width__full .t4s-current-scrollbar');
            this.megaScrollerClose = document.querySelectorAll('.t4s-type__mega.menu-width__full .t4s-current-scrollbar .close');
            this.addEventListener('mouseenter', event => {
                const megaMenuLink = event.target.closest('mega-menu-link');
                const megaMenuId = megaMenuLink.dataset.megaMenuId;
                const parentHandle = megaMenuLink.dataset.bannerLink;

                // Sub-categories panel switching
                const subcategoriesContainer = megaMenuLink.closest('.type_mn_link')?.querySelector(`.mega-subcategories-container[data-mega-menu-id="${megaMenuId}"]`);
                if (subcategoriesContainer) {
                    const panels = subcategoriesContainer.querySelectorAll('.mega-subcategory-panel');
                    const targetPanel = subcategoriesContainer.querySelector(`.mega-subcategory-panel[data-parent-handle="${parentHandle}"]`);
                    panels.forEach(p => p.classList.remove('is-active'));
                    if (targetPanel) {
                        targetPanel.classList.add('is-active');
                    }
                    // Highlight active parent link
                    const allLinks = megaMenuLink.closest('.mega-menu-parents')?.querySelectorAll('mega-menu-link');
                    if (allLinks) {
                        allLinks.forEach(l => l.classList.remove('is-hover'));
                    }
                    megaMenuLink.classList.add('is-hover');
                }

                // Legacy banner image switching (kept for backward compatibility)
                const bannerImage = document.querySelector(`.type_mn_banner[data-mega-menu-id="${megaMenuId}"] .t4s-banner-item .t4s-banner-inner img`);
                const bannerLink = document.querySelector(`.type_mn_banner[data-mega-menu-id="${megaMenuId}"] .t4s-banner-item .t4s-banner-inner a`);
                const basedImageUrl = document.querySelector(`banner-link[data-mega-menu-id="${megaMenuId}"][data-link-handle="${parentHandle}"]`);
                if(basedImageUrl && bannerImage) {
                    const widths = [100,200,400,600,700,800,900,1000,1200,1400,1600];
                    const newSrcset = widths
                        .map(w => `${basedImageUrl.dataset.imageSrc}?width=${w} ${w}w`)
                        .join(', ');

                    bannerImage.setAttribute('src', `${basedImageUrl.dataset.imageSrc}?width=800`);
                    bannerImage.setAttribute('srcset', newSrcset);
                    bannerImage.setAttribute('data-srcset', newSrcset);
                }
                if(bannerLink && basedImageUrl) {
                    bannerLink.href = `${basedImageUrl.dataset.linkUrl}`;
                }
            })
            this.megaScroller.length > 0 && this.megaScroller.forEach(mega => {
                mega.addEventListener('click', event => {
                    
                    event.preventDefault();
                    event.stopPropagation();
                    if(event.target.closest('a')) {
                        window.location.href = event.target.closest('a').href;
                        return;
                    }
                    const closestEl = event.target.closest('.mega-menu-half-container');
                    if(!closestEl) {
                        const parentEl = event.target.closest('.menu-has__offsets');
                        if(parentEl) {
                            parentEl.classList.remove('is-action__hover');
                            const halfMenu = parentEl.querySelector('.t4s-row');
                            halfMenu.setAttribute('tabindex', '-1');
                            halfMenu.blur(); // Remove focus
                            document.body.style.overflow = '';
                            document.body.focus();
                        } 
                    }
                })
            })
            this.megaScrollerClose.length > 0 && this.megaScrollerClose.forEach(close => {
                close.addEventListener('click', event => {
                    event.preventDefault();
                    event.stopPropagation();
                    const closestEl = event.target.closest('.mega-menu-half-container');
                    if(closestEl) {
                        const parentEl = event.target.closest('.menu-has__offsets');
                        if(parentEl) {
                            parentEl.classList.remove('is-action__hover');
                            const halfMenu = parentEl.querySelector('.t4s-row');
                            halfMenu.setAttribute('tabindex', '-1');
                            halfMenu.blur(); // Remove focus
                            document.body.style.overflow = '';
                            document.body.focus();
                        } 
                    }
                })
            })
        }
    }
    customElements.define('mega-menu-link', MegaMenuLink);
}